import React from 'react'
import { Button } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm'
import { useParams } from 'react-router-dom'
import { convertToFormData, sweetAlert } from '../../../utils'
import { useSaveApplicationMutation } from '../../../redux/services/ApplicationService'
import { responseError } from '../../../helpers/responseHandler'

const StepFive = ({ setActiveStep, params, isEdit, setIsEdit }) => {
  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm()
  const [editRequest, { isLoading: editLoading }] = useSaveApplicationMutation()

  const onSubmit = async data => {
    const newForm = convertToFormData({ step_no: '6', ...data })
    setIsEdit(prev => {
      return { ...prev, ...newForm }
    })
    await editRequest({ params, newForm })
      .unwrap()
      .then(res => {
        setActiveStep(5)
        if (res?.status) {
          sweetAlert(res?.message, 'success')
        }
        // if (res?.errors) {
        //     Object.entries(res?.errors)?.forEach(([key, value]) => {
        //         sweetAlert(value[0], 'error')
        //     })
        // }
      })
      .catch(err => {
        responseError(err)
      })
  }

  return (
    <>
      <div className='row justify-content-center'>
        <div className='col-xl-10'>
          <div className='card custom-card'>
            <div className='card-body'>
              <h5 className='text-center'>Social Security Information</h5>
              <div className='row'>
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  className='col-md-12'
                  id='application-status'
                >
                  <div className='row'>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Social Security Number:</Form.Label>
                        <Controller
                          name='ssn'
                          control={control}
                          defaultValue={isEdit?.ssn || ''}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <Form.Control
                              type='text'
                              placeholder='Enter Social Security Number'
                              {...field}
                              isInvalid={errors.ssn}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label htmlFor='cssv'>
                          Consent for Social Security Verification:
                        </Form.Label>
                        <Controller
                          name='cssv'
                          control={control}
                          defaultValue={isEdit?.cssv == 'true' ? true : false}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <Form.Check
                              type='checkbox'
                              defaultChecked={field.value}
                              id='cssv'
                              label='I consent to the Social Security Verification'
                              {...field}
                              isInvalid={errors.cssv}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Upload Copy of Social Security Card:</Form.Label>
                        <Controller
                          name='ssc_file'
                          control={control}
                          defaultValue={''}
                          rules={{
                            required: isEdit?.ssc_file ? false : true,
                            validate: {
                              fileSize: file => {
                                if (!file) return true // allow empty if not required
                                return (
                                  file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB'
                                )
                              },
                              fileType: file => {
                                if (!file) return true // skip if not required
                                const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf']
                                return (
                                  allowedTypes.includes(file.type) ||
                                  'Only JPEG, PNG, or PDF files are allowed'
                                )
                              },
                            },
                          }}
                          render={({ field }) => (
                            <>
                              <Form.Control
                                type='file'
                                onChange={e => field.onChange(e.target.files[0])}
                                isInvalid={errors.ssc_file}
                              />
                              {errors.ssc_file && (
                                <Form.Control.Feedback type='invalid'>
                                  {errors.ssc_file.message}
                                </Form.Control.Feedback>
                              )}
                            </>
                          )}
                        />
                        {isEdit?.ssc_file_url ? (
                          <p>
                            <a
                              href={isEdit?.ssc_file_url}
                              target='_blank'
                              className='text-primary my-1'
                            >
                              View Upload File
                            </a>
                          </p>
                        ) : (
                          '-'
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Form>
                <div className='col-lg-3 d-flex mb-3'>
                  <Button
                    variant='secondary'
                    className='mt-auto w-100'
                    onClick={() => setActiveStep(3)}
                  >
                    Previous
                  </Button>
                </div>
                {/* <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(5)}
                                    >
                                        Next
                                    </Button>
                                </div> */}
                <div className='col-lg-3 d-flex mb-3'>
                  <LoadingButtonWithForm
                    isLoading={editLoading}
                    name='Next & Save'
                    form='application-status'
                    className='text-white mt-auto w-100'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StepFive
